<mat-form-field class="app-select" [floatLabel]="asFormsControl().floatingLabelNever && 'never'">
    <mat-select
        #select
        panelClass="app-select-panel"
        disableOptionCentering
        [placeholder]="asFormsControl().placeholder"
        [disabled]="asFormsControl().disabled"
        (selectionChange)="changeValue($event)"
        (openedChange)="onTouched && onTouched()">

        <mat-select-trigger *ngIf="!asFormsControl().disableAddNew">
            <ng-container *ngIf="!isAddNewSelected; else addNewContainer">{{select.triggerValue}}</ng-container>

            <ng-template #addNewContainer><i class="fa fa-plus mr-2"></i>
                {{ asFormsControl().addNewText }}
            </ng-template>
        </mat-select-trigger>

        <mat-option
            *ngFor="let option of asFormsControl().options"
            [value]="option.value"
            [disabled]="option.disabled">
            {{option.label}}
        </mat-option>

        <mat-option [value]="true" *ngIf="!asFormsControl().disableAddNew">
            <i class="fa fa-plus mr-2"></i> {{ asFormsControl().addNewText }}
        </mat-option>
    </mat-select>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
